module.exports = __webpack_public_path__ + "static/media/iland.41d26deb.svg";